import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';

@Component({
    selector: 'app-ownership-confirmation-popup',
    templateUrl: './ownership-confirmation-popup.component.html',
    styleUrls: ['./ownership-confirmation-popup.component.scss'],
    standalone: false
})
export class OwnershipConfirmationPopupComponent implements OnInit {

  dataToPass: any;
  translate: any;
  constructor(
      public modalRef : BsModalRef, 
      private modalService: BsModalService,
      private languageTranslateService: LanguageTranslateService
  ) { }

  ngOnInit(): void {
    this.languageTranslateService.wordSrc$.subscribe(transData => {
      if (Object.keys(transData).length != 0) {
        this.translate = transData;
      }
    })
  }

  onSave(){
   this.modalService.setDismissReason('saveOwnership');
   this.modalRef.hide();
  }

}
